var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modal-banner'),(_vm.view_new_dashboard)?_c('dashboard-1'):_c('dashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }